import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=246af995&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=ts"
export * from "./newsList.vue?vue&type=script&lang=ts"
import style0 from "./newsList.vue?vue&type=style&index=0&id=246af995&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246af995",
  null
  
)

export default component.exports